// @flow

import React from "react"
import styled from "styled-components"

type Props = {
  children: Object,
  white?: boolean,
  bold?: boolean
}

const StyledHeader = styled.h1`
  color: ${p => (p.white ? "white" : "black")};
  display: inline-block;
  font-size: 26px;
  font-stretch: normal;
  font-style: normal;
  font-weight: ${p => (p.bold ? "bold" : "normal")};
  letter-spacing: normal;
  line-height: normal;
`

const TitlePrimary = ({
  white,
  bold = true,
  children
}: Props): React$Element<any> => {
  return (
    <StyledHeader white={white} bold={bold}>
      {children}
    </StyledHeader>
  )
}

export default TitlePrimary
